/* eslint jsx-a11y/label-has-associated-control: ["error", { "assert": "nesting" }] */
import { AffiliateOperation, AffiliateState } from "../../interfaces/affiliate";
import { verifiedAffiliateEnvironment } from "../../hooks/api/admin/affiliateEnvironment";
import {
  affiliateSettings,
  AffiliateSettings,
  launchPrepared,
} from "./configuration";

export function EndedBudgetRetentionPanel({
  data,
  locked,
  run,
}: {
  data?: AffiliateState;
  locked: boolean;
  run: (
    operation: AffiliateOperation,
    payload: Record<string, unknown>
  ) => Promise<boolean>;
}) {
  let settings: AffiliateSettings | undefined;
  try {
    settings = affiliateSettings(data);
  } catch {
    /* Incomplete or unrecognized settings must never replace live settings. */
  }
  const enabled = data?.ended_budget_retention_policy === "archive_v1";
  const ready =
    !locked &&
    verifiedAffiliateEnvironment(data) &&
    launchPrepared(data) &&
    data?.capabilities?.activate_ended_budget_retention === true &&
    data.ended_budget_retention_policy === "" &&
    Boolean(settings);

  return (
    <section aria-label="Ended fee-budget archival">
      <h2>Ended fee-budget archival</h2>
      <p>
        Archive verified fee-budget records to ClickHouse only after their
        chosen end date has passed by 30 days. Active, frozen and ambiguous
        records stay in backend state. Cash, points and active fee coverage
        remain unchanged.
      </p>
      <p>
        Enabling changes the persisted snapshot format. Verify the archive
        migration and upgrade every backend consumer before continuing. Older
        backend binaries cannot read the new snapshots, and this policy cannot
        be disabled afterward.
      </p>
      {enabled ? (
        <p role="status">
          {data?.ended_budget_retention?.enabled === true
            ? "Ended fee-budget archival is enabled by the backend."
            : "Archival is configured; waiting for backend confirmation."}
        </p>
      ) : (
        <p>
          {ready
            ? "The backend supports archival. Enabling preserves every current program setting."
            : "Refresh the verified backend after all consumers are upgraded and program preparation is complete."}
        </p>
      )}
      <form
        key={JSON.stringify(settings)}
        onSubmit={(event) => {
          event.preventDefault();
          if (
            !ready ||
            !settings ||
            !new FormData(event.currentTarget).has("reviewed")
          )
            return;
          run("configure", {
            ...settings,
            ended_budget_retention_policy: "archive_v1",
          });
        }}
      >
        <fieldset disabled={!ready}>
          <label>
            I verified the archive migration and all backend consumers are
            upgraded
            <input name="reviewed" type="checkbox" required />
          </label>
          <button type="submit">Enable ended-budget archival</button>
        </fieldset>
      </form>
    </section>
  );
}
